import { createSlice } from "@reduxjs/toolkit";
import { data } from "jquery";

const initialState = {
  data: [],
};

const memberSlice = createSlice({
  name: "entity",
  initialState,
  reducers: {
    setEntity: (state, action) => {
      state.data = action.payload;
    },
    clearEntity: (state) => {
      state.data = [];
    },
  },
});
export const { setEntity, clearEntity } = memberSlice.actions;

export default memberSlice.reducer;
